import React from 'react'
import PropTypes from 'prop-types'

/**
 * M055 is a component that creates either a hullabalook or a taggstar container div to be used by a third party.
 */
const M055 = ({ account }) => {
  return (
    <div
      id={account === 'hullabalook' ? 'hulla' : 'taggstar-shopper'}
      data-test={account === 'hullabalook' ? 'hulla-shopper' : 'taggstar-shopper'}
    />
  )
}

M055.propTypes = {
  /** Container type, defaults to hullabalook */
  account: PropTypes.string.isRequired
}

M055.defaultProps = {
  account: 'hullabalook'
}

export default M055
